import { useEffect, useState } from 'react';
import { getFleetAvailability, type FleetAvailability } from '../dispatch.api';

export type FleetAvailabilityState = { status: 'loading' } | { status: 'loaded'; fleet: FleetAvailability } | { status: 'error' };

export function useFleetAvailability() {
  const [state, setState] = useState<FleetAvailabilityState>({ status: 'loading' });
  const [reloads, setReloads] = useState(0);

  useEffect(() => {
    let cancelled = false;
    getFleetAvailability()
      .then((fleet) => {
        if (!cancelled) setState({ status: 'loaded', fleet });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, [reloads]);

  function reload(): void {
    setState({ status: 'loading' });
    setReloads((count) => count + 1);
  }

  return { state, reload };
}
